module.exports = __webpack_public_path__ + "static/media/iPhone14.1e1b2727.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/banner-carousel/new-banner/iPhone14.png
// module id = 526
// module chunks = 0